import { PATHS } from '../constants';

function Error() {
  return (
    <div className='bg-neutral grid min-h-dvh place-items-center'>
      <div className='grid gap-12 bg-contain bg-right bg-no-repeat p-28 text-center'>
        <div className='text-primary grid gap-8'>
          <h1 className='text-6xl leading-relaxed'>ขออภัย เกิดข้อผิดพลาดของระบบ</h1>
          <h2 className='font-normal'>กรุณาติดต่อเจ้าหน้าที่ประจำศูนย์สอบ</h2>
        </div>
      </div>
    </div>
  );
}

const ErrorRoute = {
  path: PATHS.Error,
  element: <Error />,
};

export default ErrorRoute;
